
import React from "react";

import BsyDashChartBase from '../BsyDashChartBase'
// import { BsyDashUtils } from '../../../utils/DashUtils';
// import {echarts} from '../../../plugins/echarts.js';
import BsySLoading from '../../BsySLoading';

import './index.css';
import { BsyUtils } from "../../../utils/Utils";

export default class BsyDashBarChart extends BsyDashChartBase {


    constructor(props) {
        super(props)
        this.state = {
            ...this.state
        }
    }

    _initChartOption = (e, i, n, r) => {

        let _this = this
            , opt = _this.props;
        if (e) {
            i = [React.language("report.chart.legend", {
                val: "1"
            }), React.language("report.chart.legend", {
                val: "2"
            })]
            n = [React.language("report.chart.category", {
                val: "1"
            }), React.language("report.chart.category", {
                val: "2"
            }), React.language("report.chart.category", {
                val: "3"
            }), React.language("report.chart.category", {
                val: "4"
            }), React.language("report.chart.category", {
                val: "5"
            })]
            r = [[1, 3, 8, 7, 9], [8, 6, 4, 2, 7]]
        }

        if (!r || r.length == 0) {
            this.setState({
                dataEmpty: true,
            })
            return;
        }
        this.setState({
            dataEmpty: false,
        }, () => {
            let option = {};
            let option1 = this._renderOptions(option, i, n, r);
            // console.log(JSON.stringify(option));
            if (this.myCharts) {
                this.myCharts.dispose();
                this.echartsRef.current.innerHTML = '';
            }
            this.myCharts = window.echarts.init(this.echartsRef.current);
            if (option1.onFinished) {
                this.myCharts.on('finished', function () {
                    option1.onFinished && option1.onFinished(_this.myCharts);
                });
            }
            this.myCharts.on('click', function (params) {
                let i = [];
                if (_this.yGroups && _this.yGroups[0]) {
                    let n = params.seriesName || params.name;
                    if(_this.nameMap[n]) {
                        n = _this.nameMap[n];
                    }
                    let r = _this._dealLinkData(_this.yGroups[0], n);
                    r.field = _this.yGroups[0].name
                    i.push(r)
                }
                if (_this.xGroups && _this.xGroups[0]) {
                    let a = params.category || params.name
                        , o = _this.name || _this.nameMap[a] || a
                        , s = _this._dealLinkData(_this.xGroups[0], o);
                    s.field = _this.xGroups[0].name
                    i.push(s)
                }
                if (_this.state.valueFields[0]) {
                    _this.linkParam = _this._getLinkFilterParams(i)
                    BsyUtils.applyFunc(_this, opt.onItemClick, [_this.linkParam], !1)
                }
            });
            this.myCharts.setOption(option1)
        })

    }
 
}